import { useMutation } from '@tanstack/react-query';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';
import { type CreateEventFromDifferenceRequest } from '../../../types/BaselineMeasurements';

type CreateEventFromDifferenceResponse = {};

const mutationFn = async (data: CreateEventFromDifferenceRequest) => {
  const response = await baselineMeasurementService.createEventFromDifferences(data);
  return response.data;
};

export const useCreateEventFromDifferenceMutation = () => {
  return useMutation<CreateEventFromDifferenceResponse, unknown, CreateEventFromDifferenceRequest>(mutationFn);
};
